import CellHOC from '@platform/react/hoc/list/cell'
import LabeledHOC from '@platform/react/hoc/list/labeled'
import { ListItemCellServiceItemInfo } from 'ui/Element/List/Item/Cell/ServiceItem/Info'

export default CellHOC(
  LabeledHOC(
    props => props.label, ListItemCellServiceItemInfo,
  ),
)
